const BranchIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
      <path
        d='M10.0001 14C10.0001 13.6 10.2667 13.3333 10.6667 13.3333L13.3334 13.3333L13.3334 10.6667C13.3334 10.2667 13.6001 10 14.0001 10C14.4001 10 14.6667 10.2667 14.6667 10.6667L14.6667 14C14.6667 14.4 14.4001 14.6667 14.0001 14.6667L10.6667 14.6667C10.2667 14.6667 10.0001 14.4 10.0001 14Z'
        fill='#8B5CF6'
      />
      <path
        d='M10.0001 1.99992C10.0001 1.59992 10.2667 1.33325 10.6667 1.33325L14.0001 1.33325C14.4001 1.33325 14.6667 1.59992 14.6667 1.99992L14.6667 5.33325C14.6667 5.73325 14.4001 5.99992 14.0001 5.99992C13.6001 5.99992 13.3334 5.73325 13.3334 5.33325L13.3334 2.66659L10.6667 2.66659C10.2667 2.66659 10.0001 2.39992 10.0001 1.99992Z'
        fill='#8B5CF6'
      />
      <path
        d='M1.33343 7.99992C1.33343 7.59992 1.6001 7.33325 2.0001 7.33325L6.6001 7.33325C7.66676 7.33325 8.66676 7.73325 9.4001 8.53325L14.4001 13.5333C14.6668 13.7999 14.6668 14.1999 14.4001 14.4666C14.1334 14.7333 13.7334 14.7333 13.4668 14.4666L8.46677 9.46659C8.0001 8.93325 7.33343 8.66659 6.6001 8.66659L2.0001 8.66659C1.6001 8.66659 1.33343 8.39992 1.33343 7.99992Z'
        fill='#8B5CF6'
      />
      <path
        d='M5.33341 7.99992C5.33341 7.59992 5.60008 7.33325 6.00008 7.33325L6.60008 7.33325C7.33341 7.33325 8.00008 7.06659 8.46675 6.53325L13.5334 1.53325C13.8001 1.26659 14.2001 1.26659 14.4667 1.53325C14.7334 1.79992 14.7334 2.19992 14.4667 2.46659L9.46675 7.46659C8.73341 8.19992 7.73342 8.66659 6.66675 8.66659L6.00008 8.66659C5.60008 8.66659 5.33341 8.39992 5.33341 7.99992Z'
        fill='#8B5CF6'
      />
    </svg>
  );
};

export default BranchIcon;
